.tabs {
  margin-bottom: 16px;
  flex: 1;
}
